import { useQuery } from "react-query";
import * as config from '../../../app.config';
import axios from 'axios';
import { setHeaders } from "../../../utils/basic";

const getQlpPlateStatsForDownload = async (plate_uuid) => {

    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qlp/plate_stats/tocsv/${plate_uuid}`, {
        headers: headerConfig
    });
    return data?.data;
}
export default function useFetchQlpPlateStatsDownload(plate_uuid) {
    return useQuery('QlpPlateStatsForDownload', () => getQlpPlateStatsForDownload(plate_uuid), {
        onSuccess: (data) => {
            // console.log(data);
        },

        onError: (error) => {
            console.log(error);
        },

    });
}